module.exports = __webpack_public_path__ + "img/converifai-logo-white-mini.fbed1aa1.svg";